/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'

/* TypeScript */
export type ButtonsApiProps = {
  technicalName?: Maybe<string>
  primary: CTALink
  secondary?: Maybe<CTALink>
  title?: Maybe<string>
  subtitle?: Maybe<string>
}

/* Schemas */
export const ButtonsApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  primary: CTALinkSchema,
  secondary: z.nullish(CTALinkSchema),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
})

/* Schemas validation */
type TestButtonsProps = ExpectTrue<
  Equal<ButtonsApiProps, z.infer<typeof ButtonsApiPropsSchema>>
>
